/* -------------------------------------------------------------------------------------------------
 * I18next
 * -----------------------------------------------------------------------------------------------*/

enum I18NEXT {
	routeProductsSlugReviewCreate = 'route-products-slug-review-create',
}

/* -------------------------------------------------------------------------------------------------
 * Route loader
 * -----------------------------------------------------------------------------------------------*/

enum ROUTE_LOADER {
	root = 'root',
	current = 'routes/($lang).products.$slug.review.create',
	productsSlug = 'routes/($lang).products.$slug',
}

/* -------------------------------------------------------------------------------------------------
 * Search params
 * -----------------------------------------------------------------------------------------------*/

enum SEARCH_PARAMS {
	title = 'title',
	rating = 'rating',
	comment = 'comment',
	email = 'email',
}

/* -----------------------------------------------------------------------------------------------*/

export {
	I18NEXT as PRODUCTS_SLUG_REVIEW_CREATE_I18next,
	ROUTE_LOADER as PRODUCTS_SLUG_REVIEW_CREATE_RouteLoader,
	SEARCH_PARAMS as PRODUCTS_SLUG_REVIEW_CREATE_SearchParams,
}
